<p class="mb-2">{{ text }}</p>

<button (click)="saveAndContinue()" class="button-regular mr-2">
  <span >{{ 'eventsetup.event_details.save_changes_dialog.save_and_continue' | translate }}</span>
</button>

<button (click)="continueWithoutSaving()" class="button-outline mr-2">
  <span >{{ 'eventsetup.event_details.save_changes_dialog.continue_without_saving' | translate }}</span>
</button>

<button (click)="cancel()" class="button-outline">
  {{ 'eventsetup.event_details.save_changes_dialog.cancel' | translate }}
</button>
